// Pure and storefront-safe: the one rule for what counts as a safe, explicit image location.
/** Accept explicit image locations, not bare strings the carousel would silently replace. */
export function isValidImageUrl(value: string): boolean {
  if (value === '') return true;
  if (/[\r\n\t\\]/.test(value)) return false;
  if (/^(?:\/(?!\/)|\.\.?\/)/.test(value)) return true;
  if (/^data:image\/[a-z0-9.+-]+(?:;[^,]*)?,.+$/i.test(value)) return true;
  if (!/^https?:\/\/[^/]/i.test(value)) return false;
  try {
    return new URL(value).hostname !== '';
  } catch {
    return false;
  }
}
